import yachtModelsApiService from '@/services/api/YachtModels'

const ENTITY_TYPE = 'yacht-model'
const CURRENCY_TYPE_EURO = 'EUR'
const CURRENCY_TYPE_USD = 'USD'
const CURRENCY_TYPE_GBP = 'GBP'
const CURRENCY_TYPE_SEK = 'SEK'
const CURRENCY_TYPES = [CURRENCY_TYPE_EURO, CURRENCY_TYPE_GBP, CURRENCY_TYPE_USD, CURRENCY_TYPE_SEK]

const STATUS_DRAFT = 'draft'
const STATUS_ACTIVE = 'active'

const emptyModel = {
  yacht_manufacturer_id: null,
  yacht_type_id: null,
  name: null,
  label: null,
  status: STATUS_DRAFT,
  is_sales_active: false,
  is_partners_visible: false,
  organisation_id: null,
  model_year: null,
  purchase_price: null,
  sale_price: null,
  currency: CURRENCY_TYPE_EURO,
  specifications: [],
  water_tanks: [null],
  fuel_tanks: [null],
  length: null,
  berth_count: null,
  beam: null,
  draught: null,
  mast_height: null,
  displacement: null,
  cabin_count: null,
  crew_cabin_count: null,
  crew_berth_count: null,
  toilette_count: null,
  steering_wheel_count: null,
  main_sail_area: null,
  description: null,
  files: [],
  countries: [],
  engines: [{ id: null }],
  equipment_packs: []
}

const emptyFilters = {
  id: null,
  yacht_manufacturer_id: null,
  label: null,
  model_year: null,
  model_year_from: new Date().getFullYear(),
  model_year_to: null,
  yacht_type_id: null,
  country_id: null,
  status: null,
  is_sales_active: undefined,
  sale_price_from: undefined,
  sale_price_to: undefined,
  cabins_from: undefined,
  cabins_to: undefined,
  currency: undefined,
  organisation_id: null
}

const STATUS_DATA = {
  [STATUS_DRAFT]: {
    color: 'grey darken-1',
    label: 'Draft',
    key: STATUS_DRAFT
  },
  [STATUS_ACTIVE]: {
    color: 'success',
    label: 'Published',
    key: STATUS_ACTIVE
  }
}

class YachtModel {
  constructor() {
    this.api = yachtModelsApiService
    this.emptyModel = emptyModel
    this.emptyFilters = emptyFilters

    this.ENTITY_TYPE = ENTITY_TYPE
    this.CURRENCY_TYPE_USD = CURRENCY_TYPE_USD
    this.CURRENCY_TYPE_EURO = CURRENCY_TYPE_EURO
    this.CURRENCY_TYPES = CURRENCY_TYPES

    this.statusData = STATUS_DATA

    this.STATUS_DRAFT = STATUS_DRAFT
    this.STATUS_ACTIVE = STATUS_ACTIVE
  }
}

let yachtModel = new YachtModel()

export default yachtModel
